import { Environment } from '@thema-core/models';
import { baseEnvironment } from './environment.base';

export const environment: Environment = {
  ...baseEnvironment,
  production: true,
};
